/* la despensa: Qikify labels follow the existing theme language selector. */
(function () {
  'use strict';
  if (window.ldMenuBilingual) return;
  window.ldMenuBilingual = true;
  var translations = {
  "Pantry": "Despensa",
  "Olives & Pickles": "Aceitunas y encurtidos",
  "Olives & Pickes": "Aceitunas y encurtidos",
  "Vinegars": "Vinagres",
  "Rice & Pasta": "Arroz y pasta",
  "Sauces & Broth": "Salsas y caldos",
  "Condiments": "Condimentos",
  "Fruit Preserves & Honey": "Conservas de fruta y miel",
  "Fruits Preserves & Honey": "Conservas de fruta y miel",
  "Nougats & Sweets": "Turrones y dulces",
  "Coffee, tea & drinks": "Café, té y bebidas",
  "Coffe, tea & drinks": "Café, té y bebidas",
  "Pastry Ingredients": "Ingredientes de repostería",
  "Olive Oils": "Aceites de oliva",
  "Cooking Oils": "Aceites para cocinar",
  "Dressing Oils": "Aceites para aliñar",
  "Early Harvest Oils": "Aceites de cosecha temprana",
  "Infused Oils": "Aceites aromatizados",
  "Vegetables": "Verduras",
  "Asparagus": "Espárragos",
  "Artichokes": "Alcachofas",
  "Legumes": "Legumbres",
  "Laegumes": "Legumbres",
  "Greens": "Verduras de hoja",
  "Onion & Garlic": "Cebolla y ajo",
  "Mushrooms": "Setas",
  "Tomato": "Tomate",
  "Pepper": "Pimientos",
  "Seafood": "Pescados y mariscos",
  "Fish & Seafood All": "Todos los pescados y mariscos",
  "Anchovies": "Anchoas",
  "Tuna & Fish Preserves": "Conservas de atún y pescado",
  "Seafood Preserves": "Conservas de marisco",
  "Frozen Seafood All": "Todos los pescados y mariscos congelados",
  "Prawns & Carabineros": "Gambas y carabineros",
  "Frozen Seafood": "Mariscos congelados",
  "Frozen Fish": "Pescados congelados",
  "Octopus & Others": "Pulpo y otros",
  "Octopus & Squid": "Pulpo y calamar",
  "Caviar & Sea Delicacies": "Caviar y delicias del mar",
  "Fresh Fish & Seafood  SPAIN - PREORDER": "Pescados y mariscos frescos de España · Bajo pedido",
  "Featured": "Destacados",
  "Sardines - Products": "Sardinas · Productos",
  "Sardine Serving Ideas": "Ideas para servir sardinas",
  "King Crab": "Cangrejo real",
  "Fish & Seafood Preserves": "Conservas de pescado y marisco",
  "Frozen Seafoods": "Pescados y mariscos congelados",
  "Featured - Gourmet Sardines": "Destacados · Sardinas gourmet",
  "Meat": "Carnes",
  "Lamb": "Cordero",
  "Beef": "Vacuno",
  "Cold Cuts": "Embutidos",
  "View All": "Ver todo",
  "Pork - Non Halal": "Cerdo · No halal",
  "Iberian Cold Cuts": "Embutidos ibéricos",
  "Sausages": "Salchichas",
  "Pork Bites & Pates": "Aperitivos y patés de cerdo",
  "Duck & Poultry": "Pato y aves",
  "Pate & Foie": "Patés y foie",
  "Non - Halal": "No halal",
  "Non Halal": "No halal",
  "Pork Meats": "Carnes de cerdo",
  "Submenu item": "Subcategoría",
  "Pork Sausages": "Salchichas de cerdo",
  "Iberian Pates & Spreads": "Patés y untables ibéricos",
  "Iberian Charcuterie": "Charcutería ibérica",
  "Cheese & Snacks": "Quesos y aperitivos",
  "Cheese": "Quesos",
  "Spanish Cheese": "Quesos españoles",
  "Cow Milk": "Leche de vaca",
  "Sheep Milk": "Leche de oveja",
  "Goat Milk": "Leche de cabra",
  "Bread & Snacks": "Pan y aperitivos",
  "Bread & Snaks All": "Todo el pan y los aperitivos",
  "Pate & Spreads": "Patés y untables",
  "Chips - Snacks": "Patatas fritas y aperitivos",
  "Chips & Snacks": "Patatas fritas y aperitivos",
  "Nuts": "Frutos secos",
  "Ready Made": "Platos preparados",
  "Manchego Cheese": "Queso manchego",
  "Featured - Manchego": "Destacados · Manchego",
  "Kitchen": "Cocina",
  "Paellas & Accessories": "Paelleras y accesorios",
  "Gas Burners": "Quemadores de gas",
  "Paella Pans": "Paelleras",
  "Clay Cooking": "Cocina en barro",
  "Cooking Ware": "Utensilios de cocina",
  "Table Ware": "Menaje de mesa",
  "Barbeque": "Barbacoa",
  "All for Paella": "Todo para la paella",
  "Full Menu": "Menú completo",
  "Clay Cooking Wares": "Menaje de barro",
  "Latin Flavors": "Sabores latinos",
  "Mexico": "México",
  "Argentina": "Argentina",
  "Colombia": "Colombia",
  "Peru": "Perú",
  "Acai - Superfoods": "Açaí · Superalimentos",
  "Stories to Inspire": "Historias que inspiran",
  "Our Offers & New": "Ofertas y novedades",
  "Offers - Zero Waste": "Ofertas · Cero desperdicio",
  "New Arrivals": "Novedades",
  "Gift Ideas": "Ideas para regalar",
  "Iberian Products": "Productos ibéricos",
  "Iberico Ham Parts": "Piezas de jamón ibérico",
  "Take a Tour": "Descubre la tienda",
  "Journal Articles": "Artículos",
  "Events - Journeys": "Eventos y experiencias",
  "Zero Waste Offers": "Ofertas · Cero desperdicio"
};
  var labels = Object.create(null);
  var saved = new WeakMap();
  var pending = false;
  function normalize(text) { return text.replace(/\s+/g, ' ').trim(); }
  Object.keys(translations).forEach(function (en) {
    labels[normalize(en)] = { en: en, es: translations[en] };
  });
  function spanish() {
    var settings = window._bilingualTheme && window._bilingualTheme.settings;
    if (settings && !settings.use_lang2) return false;
    var cookie = document.cookie.match(/(?:^|;\s*)sn-multiling=([^;]+)/);
    return cookie ? cookie[1] === 'lang2' : !!(settings && String(settings.primary_language) === '2');
  }
  function translate() {
    pending = false;
    var es = spanish();
    document.querySelectorAll('.tmenu_item_text').forEach(function (el) {
      // Text/HTML menu items may include custom content: do not overwrite it.
      if (el.children.length) return;
      var current = normalize(el.textContent);
      var pair = saved.get(el);
      if (!pair || (current !== normalize(pair.en) && current !== normalize(pair.es))) {
        pair = labels[current];
        // Also support future menu labels entered as English | Español.
        if (!pair && current.indexOf('|') !== -1) {
          var parts = current.split('|');
          if (parts.length === 2 && parts[0].trim() && parts[1].trim()) {
            pair = { en: parts[0].trim(), es: parts[1].trim() };
          }
        }
        if (!pair) return;
        saved.set(el, pair);
      }
      var text = es ? pair.es : pair.en;
      if (el.textContent !== text) el.textContent = text;
      var link = el.closest('.tmenu_item_link');
      if (link) ['title', 'aria-label'].forEach(function (attr) {
        var value = link.getAttribute(attr);
        if (value && (normalize(value) === normalize(pair.en) || normalize(value) === normalize(pair.es))) {
          if (value !== text) link.setAttribute(attr, text);
        }
      });
    });
  }
  function schedule() {
    if (!pending) { pending = true; window.requestAnimationFrame(translate); }
  }
  function start() {
    translate();
    new MutationObserver(function (mutations) {
      if (mutations.some(function (m) {
        var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        return (el && el.closest('.tmenu_item_text')) || Array.prototype.some.call(m.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('.tmenu_item_text') || node.querySelector('.tmenu_item_text'));
        });
      })) schedule();
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
    document.addEventListener('ld:language-change', schedule);
    // Allow selector handlers to finish writing the shared cookie first.
    document.addEventListener('click', function (event) {
      if (event.target.closest('.lang-select [data-lang]')) window.setTimeout(schedule, 0);
    });
    window.addEventListener('pageshow', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
